import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Button from '@mui/material/Button';
import Bs4GenericField from './Bs4GenericField';
import {EventEmit} from '../../Bs4Components/Bs4Utils'
import Bs4Kartoteka from '../../Bs4Kartoteka';
import zIndex from '@mui/material/styles/zIndex';

export const PLAYER_LOADED_CHANGE = 'playerLoaded';
export const bs4VarianticPlayer = {
  node: null,
  playerLoaded: false,
  eventEmit: new EventEmit(),
};

export default class Bs4Variantic extends Bs4GenericField {

  setValueBs4(value) {
    this.setValue(value || {});
  }

  ViewComponentField = (props) => {
    const formField = this;
    const bs4Kartoteka = React.useMemo(() => Bs4Kartoteka.get(this.props.bs4KartotekaId), [this.props.bs4KartotekaId]);
    const [visibility, setVisibility] = React.useState(bs4Kartoteka?.visibility);
    const [value, setValue] = React.useState(() => this.getValue() || '');
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR);    
    
    formField.refFocus = React.useRef();

    const layoutValues = React.useMemo(() => this.getValue().layout || {});

    React.useEffect(() => {
      if (bs4Kartoteka) bs4Kartoteka?.on(Bs4Kartoteka.CHANGE_VISIBILITY, setVisibility);    
  
      return () => {
        if (bs4Kartoteka) bs4Kartoteka?.off(setVisibility)
      }
    }, [setVisibility, bs4Kartoteka])

    React.useEffect(() => {
      const viewerLoaded = (event) => {
        // console.log('...Bs4Variantic.viewer .2.', event)
        bs4VarianticPlayer.playerLoaded = true;
        bs4VarianticPlayer.node = formField.refFocus.current;        
        bs4VarianticPlayer.eventEmit.trigger(PLAYER_LOADED_CHANGE)
      }

      if (formField.refFocus.current) {
        const intervalAutoClick = setInterval(() => {
          // console.log('...Bs4Variantic.viewer .?.')
          try {
            const viewer = formField.refFocus.current.api.viewer;
            if (viewer) {
              // console.log('...Bs4Variantic.viewer .1.', viewer);
              viewer.events.on('loaded', viewerLoaded);
              clearInterval(intervalAutoClick);      
            }
          } catch(error) {
            // console.log('...Bs4Variantic.viewer .e.', error)
          }
        }, 0.1 * 1000);
      }

      return () => {
        try {
          const viewer = formField.refFocus.current.api.viewer;
          if (viewer) {
            viewer.events.off('loaded', viewerLoaded);            
          }
        } catch(error) {
          // console.log('...Bs4Variantic.viewer .ee.', error)          
        }            
        bs4VarianticPlayer.playerLoaded = false;
        bs4VarianticPlayer.node = null;                    
        bs4VarianticPlayer.eventEmit.trigger(PLAYER_LOADED_CHANGE);
      }
    }, [formField.refFocus.current, bs4VarianticPlayer])
           
    const height = (this.props?.field?.height) ? parseFloat(this.props.field.height)+'px' : null;
    
    // console.log('...Bs4Variantic...', value, layoutValues);

    return (      
      <FormControl 
        id={formField.props.inputId}
        fullWidth 
        error={error.error}
        sx={{fontFamily: 'Roboto'}}
      >
        {!formField.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}     
        <variantic-player
          ref={formField.refFocus}
          component-id={value.modelId} 
          configuration-id={value.configurationId}
          documentation-title="configuration_summary"
          //disable-layout={Boolean(formField.readOnly)}
          add-documentation
          //add-viewer
          add-configuration
          add-snapshot          
          add-ic
          //disable={true}
          {...layoutValues}
          style={{
            zIndex: visibility ? 'auto' : -2000, 
            display: 'block', 
            width: '100%',
            height: height,
          }}
        />                              
      </FormControl>
    )   
  }
}